// extracted by mini-css-extract-plugin
export default {"root":"Fg1TIBWMHPgkARB4OEbv","period":"YGArgsML_xcxNTcCUDD2","placeHolderShimmer":"YM9swwEy1VoV1GYxnqD7"};